import { render, staticRenderFns } from "./GrupoComissaoList.vue?vue&type=template&id=38289cf4&scoped=true"
import script from "./GrupoComissaoList.vue?vue&type=script&lang=js"
export * from "./GrupoComissaoList.vue?vue&type=script&lang=js"
import style0 from "./GrupoComissaoList.vue?vue&type=style&index=0&id=38289cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38289cf4",
  null
  
)

export default component.exports